import useConversationsList from "@mirage/service-conversation/hooks/useConversationsList";
import { useDismissableModule } from "@mirage/service-onboarding/useDismissableModule";
import { useDashUserAttributes } from "@mirage/shared/eligibility/hooks/useDashUserAttributes";
import { useExtensionUpsell } from "@mirage/shared/util/webExtensionsHelpers";
import {
  isDashEmbeddedWeb,
  isDashStandaloneWeb,
} from "@mirage/shared/utils/environment-detection";

const MINIMUM_NUMBER_OF_CONVERSATIONS_BEFORE_UPSELL = 3;
const DISMISSED_EXTENSION_UPSELL_IN_CHAT = "dismissedExtensionUpsellInChat";

export const useExtensionUpsellInChat = () => {
  const { extensionInfo, isLoading } = useExtensionUpsell(
    "otc_growth_2025_06_27_bridge_dash_chat_extension_upsell",
  );
  const { userAttributes } = useDashUserAttributes();
  const conversationListState = useConversationsList();
  // Currently supports web on both native and embedded
  const isBridgeUserOnSupportedSurfaces =
    (isDashStandaloneWeb() || isDashEmbeddedWeb()) &&
    userAttributes?.hasDashInFss;
  const canUpsell =
    isBridgeUserOnSupportedSurfaces &&
    conversationListState.type === "loaded" &&
    conversationListState.conversationMetadatas.length >=
      MINIMUM_NUMBER_OF_CONVERSATIONS_BEFORE_UPSELL;

  const { dismissed, setDismissed } = useDismissableModule(
    DISMISSED_EXTENSION_UPSELL_IN_CHAT,
  );

  if (isLoading === false && extensionInfo && canUpsell && !dismissed) {
    return {
      extensionInfo,
      onDismiss: () => {
        setDismissed(true);
      },
      isLoading: false,
    };
  } else {
    return {
      extensionInfo: undefined,
      onDismiss: () => {},
      isLoading: isLoading || conversationListState.type === "loading",
    };
  }
};
